import districts from "./districts.component";
import districtsUrls from "./districts.urls";
import DistrictsTransforms from "./districts.transforms";

const districtsModule = angular
  .module("app.components.districts", [])
  .component("districtsPage", districts)
  .service("DistrictsTransforms", DistrictsTransforms)
  .config(districtsUrls);

export default districtsModule;



// WEBPACK FOOTER //
// ./src/pages/districts/districts.module.js